/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GraduatoriaScorrimentoDTO { 
    id?: string;
    eseguito_il?: string;
    /**
     * Nome e cognome di chi lo ha eseguito, o la sua email se l\'anagrafica e\' vuota
     */
    eseguito_da?: string;
    disponibile_importo?: number;
    disponibile_posti?: number;
    importo_utilizzato?: number;
    posti_utilizzati?: number;
    righe_finanziate?: number;
}

